import { FormFieldBase } from './form-field-base';

export class FormFieldArea extends FormFieldBase<string> {
  controlType = 'textarea';
  rows: number;

  constructor(options: {} = {}) {
    super(options);
    this.rows = options['rows'] || 3;
  }
}
